import { getChannelTags, getChannelTagsList } from '@pegasus/push-messages';
/**
 * Datalayer of Push Messages
 * */
const CAMPAIGN_GROUP_PREFIX = 'upcoming_campaigns_';
export const getCampaignTagGroup = (appdomainId, notificationTagSuffix) => {
    return `${CAMPAIGN_GROUP_PREFIX}${appdomainId}${notificationTagSuffix}`;
};
export const getCampaignTags = async (appdomainId, notificationTagSuffix = '') => {
    const tagList = await getChannelTagsList();
    return tagList[getCampaignTagGroup(appdomainId, notificationTagSuffix)] || [];
};
export const getCampaignStatus = async (campaignIdentifier, appdomainId, notificationTagSuffix = '') => {
    const subscribedList = await getCampaignTags(appdomainId, notificationTagSuffix);
    return subscribedList.includes(campaignIdentifier);
};
export const removeCampaignTag = async (campaignIdentifier, appdomainId, notificationTagSuffix = '') => {
    const tags = await getChannelTags();
    try {
        return await tags.remove(`${campaignIdentifier}`, getCampaignTagGroup(appdomainId, notificationTagSuffix));
    }
    catch (e) {
        return null;
    }
};
export const addCampaignTag = async (campaignIdentifier, appdomainId, notificationTagSuffix = '') => {
    const tags = await getChannelTags();
    if (!campaignIdentifier) {
        return null;
    }
    try {
        return await tags.add(`${campaignIdentifier}`, getCampaignTagGroup(appdomainId, notificationTagSuffix));
    }
    catch (e) {
        return null;
    }
};
export const clearSubscriptions = async (upcoming, appdomainId, notificationTagSuffix = '') => {
    const campaignIds = upcoming.map(({ campaignId }) => campaignId);
    const tags = await getCampaignTags(appdomainId, notificationTagSuffix);
    const allPromise = tags
        .filter(tag => !campaignIds.includes(tag))
        .map(tag => removeCampaignTag(tag, appdomainId, notificationTagSuffix));
    return Promise.all(allPromise);
};
//# sourceMappingURL=upcoming-campaigns.js.map